module.exports = __webpack_public_path__ + "static/media/channelimgtwo.65fd1bea.png";